<template>
  <div class="container-fluid text-left" style="margin-top:20px">
    <div class="row-fluid">
      <div class="span12">
        <div class="panel" v-for="(item,index) in list" :key="index"
          style="padding:15px 15px 0 15px; background: #f3f4f8; margin-bottom:1.5rem" @click="route(item.id)">
          <div class="row b_x tt_x_10 panel-heading" style="padding: 2px 0px 14px;">
            <div class="col-9" style="padding-left: 10px;">
              <span class="label label-info" style="font-size: 13px">{{item.community !=0?item.community:'暂无社区'}}</span>
              &nbsp;
              | <span
                style="position: relative;top: 1px; font-size: 12px;">{{item.support_start_time?item.support_start_time:""}}</span>
            </div>
            <div class="col-3 text-right" style="padding-left:0" v-if="item.assistance_paid == 2">有偿服务</div>
            <div class="col-3 text-right" style="padding-left:0" v-if="item.assistance_paid == 1">无偿服务</div>
          </div>
          <div class="row panel-body" style="padding:0px;">
            <div class="col-12 aler2t-info" role="alert"
              style="line-height:150%; letter-spacing:1px;margin-top: 10px; margin-bottom: 10px;">
              {{item.assistance_text | ellipsis}}

            </div>

            <div class="row col-12"
              style="margin-left: 0px; line-height: 25px; padding-top: 10px; padding-bottom: 10px; background: #eaecf3;">
              <samp style="font-size: 14px; color: #999; margin-right: 5px;">{{item.username}}</samp>
              <samp style="font-size: 14px; color: #999; margin-right: 5px;">{{item.telephone}}</samp>
              <samp
                style="font-size: 14px; color: #999; margin-right: 5px;">{{item.assistance_address.substring(6)}}</samp>
            </div>
          </div>
          <div class="row b_t" style="margin-bottom:0px;background: #eaecf3; " v-for="(i,j) in item.assistance_listjson"
            :key="j">
            <div class="col-6 text-left" style="margin:5px 0">
              <h5 style="color: #526171;">{{i.title}}</h5>
            </div>
            <div class="col-6 text-right" style="margin:11px 0 5px">
              <span class="label label-info" style="">
                积分 {{i.value_integral}}
              </span>
              <!-- <button type="button" class="btn btn-primary" v-if="i.value_a == 1">已接单</button>
              <button type="button" class="btn btn-primary" v-if="item.assistance_state == 2">完成结单</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <button v-if="moreShowBoolen" @click="moreShow" class="btn3"
      style="display:block;margin:15px auto 0;outline: none; color: #666; width:50%; background-color: #eee; ">更多数据</button>
    <div v-else style="text-align:center;margin-top:15px">已无更多</div>
    <!-- <div class="row-fluid">
      <div class="span12">
        <div class="jumbotron" style="padding:10px 15px" @click="$router.push('/help_show')">

          <div class="row b_x tt_x_10" style="padding: 2px 0px 14px;">
            <div class="col-9" style="padding-left: 10px;">
              <span class="label"
                style="color: #3480fa;background-color: #ffd986;border-radius: 50px/50px">未来社区</span>&nbsp;
              | 05:63
            </div>
            <div class="col-3 text-right" style="padding-left:0">等待接单</div>
          </div>
          <div class="row t_10">
            <div class="col-12" style="line-height:25px;padding-right:0">
              <span class="glyphicon glyphicon-bullhorn"></span> 有5个老人需要理发，要求平头有5个老人需要理发，要求平头有5个老人需要理发，
            </div>
            <div class="row col-12" style="margin-top:5px">
              <div class="col-3" style="padding-right:0"> <span class="glyphicon glyphicon-user"></span> 张帅</div>
              <div class="col-9">15067670999</div>
            </div>
            <div class="col-12" style="height: 3px;"></div>
            <div class="col-12 t_5 t_x_10">
              <span class="glyphicon glyphicon-flag"></span> 海门街道315号5幢400室
            </div>
            <div class="col-12" style="height: 3px;"></div>
          </div>
          <div class="row b_t tt_10 t_x_10" style="margin-bottom:0px">
            <div class="col-6">
              <h5>理发服务</h5>
            </div>
            <div class="col-6 text-right"><button type="button" class="btn btn-primary">等待接单</button></div>
          </div>
        </div>
      </div>
    </div> -->

    <div id="d_p"></div>

  </div>

</template>

<script>
export default {
  data () {
    return {
      list: [],
      moreShowBoolen: false,
      nowPage: 1
    }
  },
  props: {},
  created () { },
  mounted () {
    this.$api.getAPI('mutual/assistance/?appid=202108&type_id=3001&page=1&size=5&state=1&sort_id=1', {}).then(
      res => {
        console.log(res.data);
        //数据处理
        if (res.data.data.data[0].models.length === 5) {
          this.list = res.data.data.data[0].models
          this.aa(this.list)
          this.moreShowBoolen = true
        } else {
          this.list = res.data.data.data[0].models.slice(0, 5)
          this.aa(this.list)
          this.moreShowBoolen = false
        }
        //社区名称
        this.$api.getAPI("build/app/202108?state=1").then(res => {
          // console.log(res.data.data.frame_users);
          for (let i = 0; i < this.list.length; i++) {
            for (let j = 0; j < res.data.data.frame_users.length; j++) {
              if (this.list[i].community == res.data.data.frame_users[j].id) {
                // console.log(123);
                this.list[i].community = res.data.data.frame_users[j].value
              }
            }
          }
          // console.log(this.list);
        })
      });

    // this.$axios.get("app/mutual/assistance/?appid=202108&type_id=3001&page=1&size=5&state=1").then(res => {
    //   // this.list = res.data.data[0].models

    //   console.log(res.data.data.data[0].models);
    //   if (res.data.data.data[0].models.length === 5) {
    //     this.list = res.data.data.data[0].models
    //     this.aa(this.list)
    //     this.moreShowBoolen = true
    //   } else {
    //     this.list = res.data.data.data[0].models.slice(0, 5)
    //     this.aa(this.list)
    //     this.moreShowBoolen = false
    //   }
    //   // console.log(this.list);
    // })
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 95) {
        return value.slice(0, 95) + '...更多'
      }
      return value
    }
  },
  methods: {




    aa (list) {
      console.log(list);
      for (let i = 0; i < list.length; i++) {
        if (list[i].support_start_time == "") { } else {
          var date = new Date(list[i].support_start_time * 1000);
          var Y = date.getFullYear() + '年';
          var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
          var D = date.getDate() + ' ';
          var h = date.getHours() + ':';
          var m = date.getMinutes() + '';
          var s = date.getSeconds();
          //月

          //天
          var myDate = new Date();
          var tMonth = (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1) +
            '月';
          var tDate = myDate.getDate();
          var tHours = myDate.getHours()

          if (M == tMonth) {
            if (tDate == D) {
              //今天
              this.list[i].support_start_time = "今天" + h + m
            } else if (tDate == (Number(D) + 1)) {
              //昨天
              this.list[i].support_start_time = "昨天" + h + m
            } else {
              this.list[i].support_start_time = "本月" + D + "日 " + h + m
            }

          } else {
            this.list[i].support_start_time = M + D + h + m
          }
        }
      }
    },
    moreShow () { // 点击查询更多
      this.nowPage++
      this.$api.getAPI('mutual/assistance/?appid=202108&type_id=3001&state=1&sort_id=1&size=5&page=' +
        this.nowPage, {})
        .then(res => {
          if (res.data.data.data[0].models.length == 5) {
            this.moreShowBoolen = true
          } else {
            this.moreShowBoolen = false
          }
          for (let i = 0; i < res.data.data.data[0].models.length; i++) {
            this.list.push(res.data.data.data[0].models[i])
          }
          this.aa(this.list)
        })
    },
    route (id) {
      // console.log(id);
      this.$router.push({
        name: 'help_show',
        query: {
          id: id
        }
      })
    }
  }


}
</script>

<style>
.btn-primary {
  color: #fff;
  background-color: #01b2c2;
  border-color: #01b2c2;
}

.btn3 {
  border: none;
  outline: 0;
  background: none;
  /* background: #00a4b7bf;
  color: #fff;
  padding: 4px 5px 3px;
  font-size: 75%;
  font-weight: 700; */
}

.jumbotron {
  padding: 1rem 1rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/views/home_help.vue